// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__PoSli","row":"Footer_row__li9NR","socialMedia":"Footer_socialMedia__97OTV"};